"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolutionStatus = exports.DurationUnit = exports.ChoiceRightness = exports.PaymentType = exports.SortingOrder = exports.SortingCriterion = exports.QueryParticipantsRequestSortingOrder = exports.QueryParticipantsRequestSortingCriterion = exports.ParticipationState = exports.State = exports.ParticipantStepState = void 0;
var ParticipantStepState;
(function (ParticipantStepState) {
    ParticipantStepState["PENDING"] = "PENDING";
    ParticipantStepState["RUNNING"] = "RUNNING";
    ParticipantStepState["COMPLETED"] = "COMPLETED";
    ParticipantStepState["SKIPPED"] = "SKIPPED";
    ParticipantStepState["CONFIRMED"] = "CONFIRMED";
    ParticipantStepState["REJECTED"] = "REJECTED";
    ParticipantStepState["OVERDUE"] = "OVERDUE";
})(ParticipantStepState = exports.ParticipantStepState || (exports.ParticipantStepState = {}));
var State;
(function (State) {
    State["JOIN_REQUESTED"] = "JOIN_REQUESTED";
    State["INVITED"] = "INVITED";
    State["JOIN_REJECTED"] = "JOIN_REJECTED";
    State["PAYMENT_REQUESTED"] = "PAYMENT_REQUESTED";
    State["PAYMENT_STARTED"] = "PAYMENT_STARTED";
    State["JOINED"] = "JOINED";
    State["LEFT"] = "LEFT";
    State["REMOVED"] = "REMOVED";
    State["RUNNING"] = "RUNNING";
    State["COMPLETED"] = "COMPLETED";
    State["FAILED"] = "FAILED";
    State["PAYMENT_STARTED_OFFLINE"] = "PAYMENT_STARTED_OFFLINE";
})(State = exports.State || (exports.State = {}));
var ParticipationState;
(function (ParticipationState) {
    ParticipationState["NotStarted"] = "NotStarted";
    ParticipationState["InProgress"] = "InProgress";
    ParticipationState["Finished"] = "Finished";
})(ParticipationState = exports.ParticipationState || (exports.ParticipationState = {}));
var QueryParticipantsRequestSortingCriterion;
(function (QueryParticipantsRequestSortingCriterion) {
    QueryParticipantsRequestSortingCriterion["DEFAULT"] = "DEFAULT";
    QueryParticipantsRequestSortingCriterion["JOIN_DATE"] = "JOIN_DATE";
    QueryParticipantsRequestSortingCriterion["NAME"] = "NAME";
    QueryParticipantsRequestSortingCriterion["LAST_EVENT"] = "LAST_EVENT";
    QueryParticipantsRequestSortingCriterion["PERFORMANCE"] = "PERFORMANCE";
})(QueryParticipantsRequestSortingCriterion = exports.QueryParticipantsRequestSortingCriterion || (exports.QueryParticipantsRequestSortingCriterion = {}));
var QueryParticipantsRequestSortingOrder;
(function (QueryParticipantsRequestSortingOrder) {
    QueryParticipantsRequestSortingOrder["ORDER_DEFAULT"] = "ORDER_DEFAULT";
    QueryParticipantsRequestSortingOrder["ORDER_ASC"] = "ORDER_ASC";
    QueryParticipantsRequestSortingOrder["ORDER_DESC"] = "ORDER_DESC";
})(QueryParticipantsRequestSortingOrder = exports.QueryParticipantsRequestSortingOrder || (exports.QueryParticipantsRequestSortingOrder = {}));
var SortingCriterion;
(function (SortingCriterion) {
    SortingCriterion["DEFAULT"] = "DEFAULT";
    SortingCriterion["JOIN_DATE"] = "JOIN_DATE";
    SortingCriterion["NAME"] = "NAME";
    SortingCriterion["LAST_EVENT"] = "LAST_EVENT";
    SortingCriterion["PERFORMANCE"] = "PERFORMANCE";
})(SortingCriterion = exports.SortingCriterion || (exports.SortingCriterion = {}));
var SortingOrder;
(function (SortingOrder) {
    SortingOrder["ORDER_DEFAULT"] = "ORDER_DEFAULT";
    SortingOrder["ORDER_ASC"] = "ORDER_ASC";
    SortingOrder["ORDER_DESC"] = "ORDER_DESC";
})(SortingOrder = exports.SortingOrder || (exports.SortingOrder = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["SINGLE_PAYMENT"] = "SINGLE_PAYMENT";
    PaymentType["PAID_PLANS"] = "PAID_PLANS";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var ChoiceRightness;
(function (ChoiceRightness) {
    ChoiceRightness["NEUTRAL"] = "NEUTRAL";
    ChoiceRightness["RIGHT"] = "RIGHT";
    ChoiceRightness["WRONG"] = "WRONG";
})(ChoiceRightness = exports.ChoiceRightness || (exports.ChoiceRightness = {}));
var DurationUnit;
(function (DurationUnit) {
    DurationUnit["WEEKS"] = "WEEKS";
    DurationUnit["DAYS"] = "DAYS";
    DurationUnit["HOURS"] = "HOURS";
    DurationUnit["MINUTES"] = "MINUTES";
})(DurationUnit = exports.DurationUnit || (exports.DurationUnit = {}));
var ResolutionStatus;
(function (ResolutionStatus) {
    ResolutionStatus["COMPLETED"] = "COMPLETED";
    ResolutionStatus["SKIPPED"] = "SKIPPED";
    ResolutionStatus["UNDO"] = "UNDO";
})(ResolutionStatus = exports.ResolutionStatus || (exports.ResolutionStatus = {}));
//# sourceMappingURL=types.js.map